import { render, staticRenderFns } from "./Thanksgiving_foodItem.vue?vue&type=template&id=6681d63d&scoped=true"
import script from "./Thanksgiving_foodItem.vue?vue&type=script&lang=ts"
export * from "./Thanksgiving_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./Thanksgiving_foodItem.vue?vue&type=style&index=0&id=6681d63d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681d63d",
  null
  
)

export default component.exports